import { Objective } from 'src/app/models/schema';

/**
 * Load Objectives
 * Loads all objectives for the active partner
 */
export class LoadObjectives {
  static readonly type = '[Objectives] Load Objectives';
  constructor(public partnerId: string) {}
}

export class LoadObjectivesSuccess {
  static readonly type = '[Objectives] Load Objectives Success';
  constructor(public objectives: Objective[]) {}
}

export class LoadObjectivesFailure {
  static readonly type = '[Objectives] Load Objectives Failure';
  constructor(public error: string) {}
}

/**
 * Add Objectives Batch
 * Add multiple objectives at once (used during goal creation)
 */
export class AddObjectivesBatch {
  static readonly type = '[Objectives] Add Objectives Batch';
  constructor(public objectives: Objective[], public partnerId: string) {}
}

export class AddObjectivesBatchSuccess {
  static readonly type = '[Objectives] Add Objectives Batch Success';
  constructor(public objectives: Objective[]) {}
}

export class AddObjectivesBatchFailure {
  static readonly type = '[Objectives] Add Objectives Batch Failure';
  constructor(public error: string) {}
}

/**
 * Update Objective
 * Update a single objective
 */
export class UpdateObjective {
  static readonly type = '[Objectives] Update Objective';
  constructor(public objective: Objective, public partnerId: string) {}
}

export class UpdateObjectiveSuccess {
  static readonly type = '[Objectives] Update Objective Success';
  constructor(public objective: Objective) {}
}

export class UpdateObjectiveFailure {
  static readonly type = '[Objectives] Update Objective Failure';
  constructor(public error: string) {}
}

/**
 * Delete Objective
 * Delete a single objective
 */
export class DeleteObjective {
  static readonly type = '[Objectives] Delete Objective';
  constructor(public objectiveId: string, public partnerId: string) {}
}

export class DeleteObjectiveSuccess {
  static readonly type = '[Objectives] Delete Objective Success';
  constructor(public objectiveId: string) {}
}

export class DeleteObjectiveFailure {
  static readonly type = '[Objectives] Delete Objective Failure';
  constructor(public error: string) {}
}

/**
 * Delete Objectives By Goal
 * Delete all objectives associated with a goal (cascade delete)
 */
export class DeleteObjectivesByGoal {
  static readonly type = '[Objectives] Delete Objectives By Goal';
  constructor(public goalId: string, public partnerId: string) {}
}

export class DeleteObjectivesByGoalSuccess {
  static readonly type = '[Objectives] Delete Objectives By Goal Success';
  constructor(public goalId: string) {}
}

export class DeleteObjectivesByGoalFailure {
  static readonly type = '[Objectives] Delete Objectives By Goal Failure';
  constructor(public error: string) {}
}

/**
 * Reset Objectives State
 * Clear objectives when user signs out or changes teams
 */
export class ResetObjectivesState {
  static readonly type = '[Objectives] Reset State';
}
